<mat-stepper #stepper class="start-trial-mat-stepper">
  <mat-step>
    <div class="flex flex-col items-center justify-end min-h-dvh py-[60px]">
      <div class="w-full h-[180px] mb-9">
        <img class="mx-auto max-w-[420px]" ngSrc="assets/icons/activate-trial.svg" alt="activate-trial" width="375" height="181">
      </div>
      <p class="text-white text-center font-bold text-2xl leading-[1.33] px-5 !mb-[15px]" [innerHTML]="'dialog_first_active_start_trial.title1' | translate"></p>
      <p class="text-white opacity-50 text-center  leading-[1.6] px-5 !mb-6" [ngClass]="currentLang === 'ru' ? 'text-[14px]' : 'text-base'" [innerHTML]="'dialog_first_active_start_trial.title2' | translate"></p>
      <button (click)="openTriggersDialog()" class="flex items-center mx-auto px-[17px] py-[13px] bg-fraud-green-900 rounded-[20px] mb-[22px]">
        <img class="mr-[7px]" ngSrc="assets/icons/activate-shield.svg" alt="activate-shield" width="14" height="16">
        <span class="text-white text-[15px] leading-none mr-3">{{ 'dialog_first_active_start_trial.title3' | translate }}</span>
        <img class="" ngSrc="assets/icons/activate-response.svg" alt="activate-response" width="12" height="13">
      </button>
      <div class="flex items-center justify-between w-full px-7">
        <div class="pagination flex items-center gap-3">
          <div class="step w-[26px] h-[5px] rounded-full bg-white" (click)="stepper.selectedIndex = 0"></div>
          <div class="step w-[5px] h-[5px] rounded-full bg-white" (click)="stepper.selectedIndex = 1"></div>
          <div class="step w-[5px] h-[5px] rounded-full bg-white" (click)="stepper.selectedIndex = 2"></div>
        </div>
        <button class="w-full h-full max-w-[52px] max-h-[52px]" matStepperNext>
          <img class="" ngSrc="assets/icons/activate-next-step.svg" alt="activate-next-step" width="52" height="52">
        </button>
      </div>
    </div>
  </mat-step>

  <mat-step>
    <div class="flex flex-col items-center justify-end min-h-dvh pb-[60px]" [ngClass]="currentLang === 'ru' ? 'pt-[20px]' : 'pt-[60px]'">
      <div class="w-full max-w-[310px] mb-9">
        <img class="" ngSrc="assets/icons/activate-reports.svg" alt="activate-reports" width="312" height="230">
      </div>
      <p class="text-white text-center font-bold text-2xl leading-[1.33] px-5 !mb-[15px]" [innerHTML]="'dialog_first_active_start_trial.title4' | translate"></p>
      <p class="text-white opacity-50 text-center text-base leading-[1.6] px-5" [ngClass]="currentLang === 'ru' ? '!mb-[40px]' : '!mb-[86px]'" [innerHTML]="'dialog_first_active_start_trial.title5' | translate"></p>
      <div class="flex items-center justify-between w-full px-7">
        <div class="pagination flex items-center gap-3">
          <div class="step w-[5px] h-[5px] rounded-full bg-white" (click)="stepper.selectedIndex = 0"></div>
          <div class="step w-[26px] h-[5px] rounded-full bg-white" (click)="stepper.selectedIndex = 1"></div>
          <div class="step w-[5px] h-[5px] rounded-full bg-white" (click)="stepper.selectedIndex = 2"></div>
        </div>
        <button class="w-full h-full max-w-[52px] max-h-[52px]" matStepperNext>
          <img class="" ngSrc="assets/icons/activate-next-step.svg" alt="activate-next-step" width="52" height="52">
        </button>
      </div>
    </div>
  </mat-step>

  <mat-step>
    <div class="flex flex-col items-center justify-end min-h-dvh py-[60px]">
      <div class="w-full max-w-[314px] flex items-center justify-center gap-[15px] mb-9">
        <img class="" ngSrc="assets/img/activate-free.png" alt="activate-free" width="159" height="181">
        <ul class="flex flex-col gap-3 max-w-[150px]">
          <li class="text-white flex items-start gap-1 text-[13px] leading-[1.46]">
            <img class="" ngSrc="assets/icons/list-check.svg" alt="list-check" width="18" height="18">
            <span [innerHTML]="'dialog_first_active_start_trial.title9' | translate"></span>
          </li>
          <li class="text-white flex items-start gap-1 text-[13px] leading-[1.46]">
            <img class="" ngSrc="assets/icons/list-check.svg" alt="list-check" width="18" height="18">
            {{ 'dialog_first_active_start_trial.title6' | translate }}
          </li>
        </ul>
      </div>
      <p class="text-white text-center font-bold text-2xl leading-[1.33] px-5 !mb-[15px]" [innerHTML]="'dialog_first_active_start_trial.title7' | translate"></p>
      <p class="text-white opacity-50 text-center text-base leading-[1.6] px-5 !mb-[86px]">{{ 'dialog_first_active_start_trial.title8' | translate }}</p>
      <div class="flex items-center justify-between w-full px-7">
        <div class="pagination flex items-center gap-3">
          <div class="step w-[5px] h-[5px] rounded-full bg-white" (click)="stepper.selectedIndex = 0"></div>
          <div class="step w-[5px] h-[5px] rounded-full bg-white" (click)="stepper.selectedIndex = 1"></div>
          <div class="step w-[26px] h-[5px] rounded-full bg-white" (click)="stepper.selectedIndex = 2"></div>
        </div>
        <button [ngClass]="currentLang === 'ru' ? 'text-[16px] gap-1 p-[10px] max-w-[240px]' : 'text-[18px] gap-2.5 p-[15px]'" class="bg-white font-medium  text-fraud-red-700 flex items-center  rounded-[26px]"  [mat-dialog-close]="true">
          {{ 'dialog_first_active_start_trial.button' | translate }}
          <img class="" ngSrc="assets/icons/arrow-red-right.svg" alt="arrow-red-right" width="22" height="18">
        </button>
      </div>
    </div>
  </mat-step>
</mat-stepper>
